module.exports = __webpack_public_path__ + "static/media/activation-home-android-mweb.7d401802.webp";